import React from 'react';
import styles from './FeedListItem.module.css';
import {
  logClickOriginLink,
  webSectionName,
} from '../../../../shared/models/Analytics';

const linkItem = (name, onClick) => {
  return (
    <span className={`namesAndObjects ${styles.name}`} onClick={onClick}>
      {`> ${name || ''}`}
    </span>
  );
};

function ListItemTitle(
  history,
  navigating,
  type,
  verb,
  event,
  group,
  challenge,
  analyticsObj,
) {
  if (type === 'event') {
    if (verb === 'create') return `added an event`;
    else if (verb === 'going' || verb === 'interested') return `is ${verb}`;
    else if (verb === 'checked_in') return `checked into`;
  } else if (type === 'post') {
    if (!analyticsObj) analyticsObj = {};
    analyticsObj.section_name = webSectionName();
    if (event) {
      analyticsObj.click_text = event.name;
      if (navigating) return `posted on ${event.name || ''}`;
      const click = () => {
        logClickOriginLink(analyticsObj);
        history.push(`/events/${event.id}`);
      };
      return linkItem(event.name, click);
    } else if (group) {
      analyticsObj.click_text = group.name;
      if (navigating) return `posted on ${group.name || ''}`;
      const click = () => {
        logClickOriginLink(analyticsObj);
        history.push(`/groups/${group.id}`);
      };
      return linkItem(group.name, click);
    } else if (challenge) {
      analyticsObj.click_text = challenge.name;
      if (navigating) return `posted on ${challenge.name || ''}`;
      const click = () => {
        logClickOriginLink(analyticsObj);
        history.push(`/challenges/${challenge.id}`);
      };
      return linkItem(challenge.name, click);
    } else {
      return 'posted';
    }
  }
}

export default ListItemTitle;
